export function findNAICSCode(input, naicsCodes) {

  if (!input || input && input.length < 2) {
    return false;
  }

  let inputArr = [];
  if (input.indexOf(" ") >= 0) {
    inputArr = input.split(" ");
  }else{
    inputArr.push(input);
  }

  let newNaicsCodes = [];

  naicsCodes.forEach(item => {
    let foundUnmatchedParameter = false;
    inputArr.forEach(inputItem =>{
      let itemToMatch = item.name.toLowerCase();
      if (parseInt(inputItem)) {
        itemToMatch = item.description__value;
      } else {
        inputItem = inputItem.toLowerCase();
        if(inputItem.includes("(") || inputItem.includes(")")){
          return;
        }
      }

      const regExMatch = itemToMatch.match(inputItem);

      if(regExMatch===null){
        foundUnmatchedParameter = true;
      }
    });
    if (!foundUnmatchedParameter && newNaicsCodes.indexOf(item) === -1) {
      newNaicsCodes.push(item);
    }
  });
  return newNaicsCodes;
}



/** WEBPACK FOOTER **
 ** ./src/components/establishment/NAICS/NaicsLookup.js
 **/